var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Service = (function (Service) {

        Service.call = function (options) {
            var baseUrl, defOpts, opts, rewritedUrl, onErrorInternal;

            defOpts = {
                async: true,
                method: 'POST',
                url: '#',
                data: {},
                rawdata: false,
                servicenamespace:'services',
                onSuccess: function (response) {
                },
                onFailure: function (err) {
                    throw err;
                },
                onUnauthenticated: function (url) {
                    throw new Error('not implemented: onUnauthenticated(url)');
                }
            };

            opts = _.extend(defOpts, options);

            baseUrl = document.location.protocol.toLowerCase() + '//' +
                document.location.host.toLowerCase() + '/';

            rewritedUrl = baseUrl + opts.servicenamespace + '/';

            rewritedUrl += opts.url;

            if (this.query)
                rewritedUrl += this.query;

            onErrorInternal = function (ex) {
                if (ex && ex.responseJSON && ex.responseJSON.ExceptionType) {
                    var typeName = ex.responseJSON.ExceptionType.split('.').pop();

                    if (typeName === 'AuthenticationServiceException') {
                        if (typeof (opts.onUnauthenticated) === 'function') {
                            opts.onUnauthenticated(ex.responseJSON.Message);
                        }
                        else {
                            throw ex;
                        }
                    }
                    else {
                        if (typeof (opts.onFailure) === 'function') {
                            opts.onFailure(ex);
                        }
                        else {
                            throw ex;
                        }
                    }
                }
                else {
                    if (typeof (opts.onFailure) === 'function') {
                        opts.onFailure(ex);
                    }
                    else {
                        throw ex;
                    }
                }
            };

            $.ajax({
                async: opts.async || true,
                type: opts.method,
                dataType: opts.rawdata ? 'text' : 'json',
                contentType: opts.rawdata ? '' : 'application/json; charset=UTF-8',
                ContentType: opts.rawdata ? '' : 'application/json; charset=UTF-8',
                url: rewritedUrl,
                data: (opts.method == 'GET') ? null : opts.rawdata ? opts.data : JSON.stringify(opts.data),
                success: function (response) {

                    var obj = response;

                    if (response.d)
                        obj = response.d;

                    if (typeof obj === 'string' || obj instanceof String)
                        obj = JSON.parse(obj);

                    if (typeof (opts.onSuccess) === 'function') {
                        opts.onSuccess(obj);
                    }
                },
                failure: function (ex) {
                    onErrorInternal(ex);
                },
                error: function (ex) {
                    onErrorInternal(ex);
                }
            });
        };

        return Service;

    })(Vendd.Service || {});

    return Vendd;

})(Vendd || {});